// extracted by mini-css-extract-plugin
export var addressContent = "custom-option-module--addressContent--1a5ad";
export var addressMain = "custom-option-module--addressMain--f1bb7";
export var addressSecondary = "custom-option-module--addressSecondary--1c17e";
export var almaCheckboxIcon = "custom-option-module--almaCheckboxIcon--e2696";
export var container = "custom-option-module--container--4cd27";